import { render, staticRenderFns } from "./FileOperations.vue?vue&type=template&id=1bc17a38&scoped=true"
import script from "./FileOperations.vue?vue&type=script&lang=js"
export * from "./FileOperations.vue?vue&type=script&lang=js"
import style0 from "./FileOperations.vue?vue&type=style&index=0&id=1bc17a38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc17a38",
  null
  
)

export default component.exports